
import {Component, Vue} from 'vue-property-decorator';
import {dispatchUserLogOut} from '@/store/main/actions';
import {commitSetDashboardShowDrawer} from '@/store/main/mutations';
import {readDashboardShowDrawer} from '@/store/main/getters';
import {appName} from '@/env';

@Component({})
export default class AppToolbar extends Vue {

  public appName = appName;

  private items = [

    {
      icon: 'mdi-account',
      href: '#',
      to: '/main/profile',
      title: this.$t('profile'),
      click: this.doNoting,
    },
    {divider: true},
    {
      icon: 'mdi-power',
      href: '#',
      to: null,
      title: this.$t('exit'),
      click: this.logout,
    },
  ];

  public switchShowDrawer() {
    commitSetDashboardShowDrawer(
        this.$store,
        !readDashboardShowDrawer(this.$store),
    );
  }

  public doNoting() {
    return;
  }

  public async logout() {
    await dispatchUserLogOut(this.$store);
  }
}
